<template>
  <div class="form">
    <div class="form-header" v-text="title"></div>
    <div>
      <div class="form-group" v-for="(item, index) in items" :key="index">
        <div class="form-label" :style="{display: showTitleItem ? 'block' : 'none'}">{{item.title}}</div>
        <div class="form-input-group">
          <div class="form-input-group-addon" v-if="item.icon && item.inputType!='calendarpicker'"><i :class="item.icon"></i></div>
          <dig-calendarpicker v-if="item.inputType=='calendarpicker'" class="form-control" v-model="values[item.name]"></dig-calendarpicker>
          <input v-if="item.inputType=='input'" class="form-control" :type="item.type" :placeholder="item.title" v-model="values[item.name]">
          <select v-if="item.inputType=='select'" class="form-control" v-model="values[item.name]">
            <option selected="true" disabled="disabled">Choose</option>
            <option v-for="option in item.options" :key="option.id" :value="option.id">{{option.name}}</option>
          </select>
          <dig-autocompletelist v-if="item.inputType=='autocompletelist'" class="form-control" v-model="values[item.name]" :endpoint="item.endpoint" :tag="item.tag"></dig-autocompletelist>
        </div>
      </div>
    </div>
    <div class="form-footer">
      <dig-button type="button-info" text="Submit" @click.native="OnSubmit" ref=btnSubmit :fullwidth=fullwidthButton :isLoading=isLoading></dig-button>
    </div>
  </div>
</template>

<script>
import Button from './button.vue'
import CalendarPicker from './calendarpicker.vue'
import AutocompleteList from './autocompletelist.vue'

export default {
  data() {
		return {
			values : {},
		};
	},
	props: {
		items:Array,
		title:String,
		showTitleItem:Boolean,
		fullwidthButton:Boolean,
		isLoading:Boolean
	},
	components: {
		'dig-button':Button,
		'dig-calendarpicker':CalendarPicker,
		'dig-autocompletelist':AutocompleteList
	},
	methods: {
		OnSubmit:function() {
			//validate
			var data = {};
			for (var i = 0; i < this.items.length; ++i) {
				var itemName = this.items[i].name;
				if (this.items[i].required && !this.values[itemName]) {
					alert(this.items[i].title + ' can\'t be empty');
					return;
				}
				data[itemName] = this.values[itemName];
			}
			this.$emit('OnSubmit', data);
		},
		SetValues:function(vals) {
			this.values = vals;
		}
	},
}
</script>

<style scoped>
.form {
  border-top: 5px solid #001b3d;
  padding: 5px;
  font-size: 0.9em;
}
.form-header, .form-group {
  display: -webkit-flex;
  display: flex;
  padding: 8px;
}
.form-header {
  margin-bottom: 1rem;
  padding-top: 0.5rem;
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.1;
  color: #001b3d;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.form-group {
  display: -webkit-flex;
  display: flex;
}
.form-label {
  -webkit-flex: 1;
  flex: 1;
  padding-top: calc(0.5rem - 1px * 2);
  padding-bottom: calc(0.5rem - 1px * 2);
  text-transform: capitalize;
}
.form-input-group {
  -webkit-flex: 5;
  flex: 5;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row;
  flex-flow: row;
}
.form-input-group-addon, .form-control {
  padding: 0.5rem 0.7rem;
  border: 1px solid #cecece;
  font-size: 0.9rem;
  line-height: 1.25;
  color: #464a4c;
}
.form-input-group-addon {
  background-color: #eceeef;
  border-radius: 0.25rem;
  border-right: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.form-input-group-addon > i {
  max-width: 10px;
}
.form-control {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  background-color: #fff;
  -webkit-flex: 1 1 auto;
  flex: 1 1 auto;
}
.form-footer {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  display: -webkit-flex;
  display: flex;
}
@media all and (max-width: 640px) {
  .form-group {
    -webkit-flex-flow: column;
    flex-flow: column;
  }
}
</style>
